export const actionTypes: any = {
  // get
  GET_ALL_NABIL_AUCTION_CATEGORY_START: 'GET_ALL_NABIL_AUCTION_CATEGORY_START',
  GET_ALL_NABIL_AUCTION_CATEGORY_SUCCESS: 'GET_ALL_NABIL_AUCTION_CATEGORY_SUCCESS',
  GET_ALL_NABIL_AUCTION_CATEGORY_FINISH: 'GET_ALL_NABIL_AUCTION_CATEGORY_FINISH',

  // extended hours
  GET_NABIL_AUCTION_CATEGORY_START: 'GET_NABIL_AUCTION_CATEGORY_START',
  GET_NABIL_AUCTION_CATEGORY_SUCCESS: 'GET_NABIL_AUCTION_CATEGORY_SUCCESS',
  GET_NABIL_AUCTION_CATEGORY_FINISH: 'GET_NABIL_AUCTION_CATEGORY_FINISH',

  // add branch
  ADD_NABIL_AUCTION_CATEGORY_START: 'ADD_NABIL_AUCTION_CATEGORY_START',
  ADD_NABIL_AUCTION_CATEGORY_SUCCESS: 'ADD_NABIL_AUCTION_CATEGORY_SUCCESS',
  ADD_NABIL_AUCTION_CATEGORY_FINISH: 'ADD_NABIL_AUCTION_CATEGORY_FINISH',
  RESET_NABIL_AUCTION_CATEGORY: 'RESET_NABIL_AUCTION_CATEGORY',

  // update SEARCH_TAG
  UPDATE_NABIL_AUCTION_CATEGORY_START: 'UPDATE_NABIL_AUCTION_CATEGORY_START',
  UPDATE_NABIL_AUCTION_CATEGORY_SUCCESS: 'UPDATE_NABIL_AUCTION_CATEGORY_SUCCESS',
  UPDATE_NABIL_AUCTION_CATEGORY_FINISH: 'UPDATE_NABIL_AUCTION_CATEGORY_FINISH',

  // delete SEARCH_TAG
  DELETE_NABIL_AUCTION_CATEGORY_START: 'DELETE_NABIL_AUCTION_CATEGORY_START',
  DELETE_NABIL_AUCTION_CATEGORY_SUCCESS: 'DELETE_NABIL_AUCTION_CATEGORY_SUCCESS',
  DELETE_NABIL_AUCTION_CATEGORY_FINISH: 'DELETE_NABIL_AUCTION_CATEGORY_FINISH',

  // Enable SEARCH_TAG
  ENABLE_NABIL_AUCTION_CATEGORY_REQUEST: 'ENABLE_NABIL_AUCTION_CATEGORY_REQUEST',
  ENABLE_NABIL_AUCTION_CATEGORY_SUCCESS: 'ENABLE_NABIL_AUCTION_CATEGORY_SUCCESS',
  ENABLE_NABIL_AUCTION_CATEGORY_FINISH: 'ENABLE_NABIL_AUCTION_CATEGORY_FINISH',

  // Disable SEARCH_TAG
  DISABLE_NABIL_AUCTION_CATEGORY_REQUEST: 'DISABLE_NABIL_AUCTION_CATEGORY_REQUEST',
  DISABLE_NABIL_AUCTION_CATEGORY_SUCCESS: 'DISABLE_NABIL_AUCTION_CATEGORY_SUCCESS',
  DISABLE_NABIL_AUCTION_CATEGORY_FINISH: 'DISABLE_NABIL_AUCTION_CATEGORY_FINISH',

  // Enable SEARCH_TAG
  SINGLE_ENABLE_NABIL_AUCTION_CATEGORY_REQUEST: 'SINGLE_ENABLE_NABIL_AUCTION_CATEGORY_REQUEST',
  SINGLE_ENABLE_NABIL_AUCTION_CATEGORY_SUCCESS: 'SINGLE_ENABLE_NABIL_AUCTION_CATEGORY_SUCCESS',
  SINGLE_ENABLE_NABIL_AUCTION_CATEGORY_FINISH: 'SINGLE_ENABLE_NABIL_AUCTION_CATEGORY_FINISH',

  // Disable SEARCH_TAG
  SINGLE_DISABLE_NABIL_AUCTION_CATEGORY_REQUEST: 'SINGLE_DISABLE_NABIL_AUCTION_CATEGORY_REQUEST',
  SINGLE_DISABLE_NABIL_AUCTION_CATEGORY_SUCCESS: 'SINGLE_DISABLE_NABIL_AUCTION_CATEGORY_SUCCESS',
  SINGLE_DISABLE_NABIL_AUCTION_CATEGORY_FINISH: 'SINGLE_DISABLE_NABIL_AUCTION_CATEGORY_FINISH',

  // sort
  SORT_NABIL_AUCTION_CATEGORY_START: 'SORT_NABIL_AUCTION_CATEGORY_START',
  SORT_NABIL_AUCTION_CATEGORY_SUCCESS: 'SORT_NABIL_AUCTION_CATEGORY_SUCCESS',
  SORT_NABIL_AUCTION_CATEGORY_FINISH: 'SORT_NABIL_AUCTION_CATEGORY_FINISH',
  SORT_NABIL_AUCTION_CATEGORY_RESET: 'SORT_NABIL_AUCTION_CATEGORY_RESET',
}
